// React
import React, { useCallback, useState } from 'react';
import {
  Col,
  Card,
  CardBody,
  ButtonGroup,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledButtonDropdown,
} from 'reactstrap';

// Containers Injections
import { ModalDelete } from '../../containers/componentsInjection';

export const CardAccount = ({ item, handleEdit, handleDelete }) => {
  const [registerId, setRegisterId] = useState(null);
  const [modal_delete, setModal_delete] = useState(false);

  function generateAvatar(text, foregroundColor, backgroundColor) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    canvas.width = 200;
    canvas.height = 200;

    // Draw background
    context.fillStyle = backgroundColor;
    context.fillRect(0, 0, canvas.width, canvas.height);

    // Draw text
    context.font = 'bold 100px Arial';
    context.fillStyle = foregroundColor;
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillText(text, canvas.width / 2, canvas.height / 2);

    return canvas.toDataURL('image/png');
  }

  const toggleModal = useCallback(
    (id) => {
      setRegisterId(id);
      setModal_delete(!modal_delete);
    },
    [modal_delete]
  );

  return (
    <Col md={3}>
      <Card>
        <CardBody>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <img
                src={generateAvatar(
                  item.name.substring(0, 2),
                  'white',
                  `#${Math.floor(
                    ((Number(item.id) + 20) / 100) * 16777215
                  ).toString(16)}`
                )}
                className="rounded-circle avatar-sm"
                alt=""
              />
              <div
                style={{
                  marginLeft: 10,
                  marginTop: 5,
                }}
              >
                <h6>
                  {item.name} <br /> {item.type}
                </h6>
              </div>
            </div>
            <ButtonGroup>
              <UncontrolledButtonDropdown>
                <DropdownToggle
                  color="primary"
                  className="ri-more-2-line fs-20"
                  tag={'i'}
                  style={{
                    cursor: 'pointer',
                  }}
                ></DropdownToggle>
                <DropdownMenu className="user-select-none">
                  <DropdownItem
                    className="dropdown-item"
                    onClick={() => handleEdit(item)}
                  >
                    <i
                      className="ri-edit-line"
                      style={{
                        marginRight: 10,
                      }}
                    />
                    Editar
                  </DropdownItem>

                  <div className="dropdown-divider"></div>
                  <DropdownItem
                    className="dropdown-item"
                    onClick={() => toggleModal(item.id)}
                  >
                    <i
                      className="ri-delete-bin-line"
                      style={{
                        marginRight: 10,
                      }}
                    />
                    Excluir
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </ButtonGroup>
          </div>
        </CardBody>
      </Card>

      <ModalDelete
        isOpen={modal_delete}
        handleDelete={() => {
          handleDelete(registerId);
          setModal_delete(!modal_delete);
        }}
        goBack={() => setModal_delete(!modal_delete)}
      />
    </Col>
  );
};
